import { Box, Grid, Button, IconButton } from "@mui/material";
import React, { FC, useState, useEffect } from "react";
import MFTopBanner from "components/MFTopBanner";
import GradientCard from "components/GradientCard";
import { load, remove, save } from "../../constants/storage";
import { H3, H4, H5 } from "../../components/Typography";
import { useAppDispatch } from "../../store/hooks";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { getMFPortfolioData } from "../../redux/actions/PortfolioAction";
import * as Models from "../../models";
import FormatCurrency from "../../constants/formateCurrency";
import { getUserInfo } from "../../redux/actions/UserAction";
import {
  MUTUAL_FUND_TYPES,
  FUNDS_CATEGORY_TILES,
} from "../../constants/constant";
import CircularProgress from "@mui/material/CircularProgress";
import TaxSavingModel from "components/TaxSavingModel";
import { getSIPList } from "../../redux/actions/PortfolioAction";

const MFDashboard: FC = () => {
  //navigation
  let navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const [mfDetails, setMfDetails] = useState<any>();
  const [customerStatus, setCustomerStatus] = React.useState();
  const [taxItem, setTaxItem] = React.useState();
  const [allSIPMfHoldingList, setAllSIPMfHoldingList] = React.useState([]);

  useEffect(() => {
    checkToken();
  }, []);

  const checkToken = async () => {
    let token = await load("token");
    if (token === undefined) {
      remove("userData");
      remove("token");
      toast.success("Session expired, please login again.");
      navigate("/login");
    } else {
      getPortfolioData();
      getUserInfomation();
      let userDetail: any = load("userData");
      let userDetails = JSON.parse(userDetail);
      if (userDetails?.mfia_id != null) {
        getAllSIPList();
      }
    }
  };
  let SIP_Data = {
    title: "All Mutual",
    type: "ALL",
  };
  const getUserInfomation = async () => {
    let token = load("token");
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    const req: Models.GETUSER_INFO_REQUEST = {
      id: userDetails.id,
      mobile: userDetails.mobile,
      partner: userDetails?.refcode,
      source: "web",
    };

    dispatch(getUserInfo(req, `bearer ${token}`))
      .then(async (response: any) => {
        if (response.statusCode === 400) {
          return;
        }
        await save("userData", JSON.stringify(response?.data[0]));
        setCustomerStatus(response);
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };

  const getPortfolioData = async () => {
    setLoading(true);
    let token: any = load("token");
    let userDetail: any = load("userData");
    let userDeatils = JSON.parse(userDetail);
    const data: Models.MutualFundPortfolioRequest = {
      id: userDeatils.id,
      mobile: userDeatils.mobile,
      partner: userDeatils?.refcode,
      source: "web",
    };
    dispatch(getMFPortfolioData(data, `bearer ${token}`))
      .then(async (response: any) => {
        if (response.statusCode === 400) {
          return;
        }
        setMfDetails(response?.mf_data ?? "0");
        setLoading(false);
      })
      .catch((error: any) => {
        console.log("getPortfolioData__error", error);
        setLoading(false);
      });
  };

  //add taxSaving
  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleSave = () => {
    setOpenModal(false);
    navigate("/mutualfundcollections", {
      state: {
        item: taxItem,
        customer: customerStatus,
      },
    });
  };

  const getAllSIPList = async () => {
    setLoading(true);
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    let token = load("token");
    dispatch(getSIPList(userDetails?.mfia_id, `${token}`))
      .then(async (response: any) => {
        setLoading(false);
        if (response.statusCode == 200) {
          setAllSIPMfHoldingList(response.data);
        }
        if (response.statusCode == 404) {
          toast.error(response?.message);
          return;
        }
      })
      .catch((error: any) => {
        toast.error(error);
        setLoading(false);
      });
  };

  return (
    <Grid
      sx={{
        pt: 2,
        pb: 2,
      }}
    >
      {loading ? (
        <Grid
          height="100vh"
          display="flex"
          flexDirection="column"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Grid>
      ) : (
        <>
          <TaxSavingModel
            open={openModal}
            handleClose={handleCloseModal}
            handleSave={handleSave}
          />
          <MFTopBanner />
          <Grid
            container
            spacing={2}
            sx={{
              mt: 0.5,
            }}
          >
            <Grid
              xs={12}
              md={8}
              sx={{
                padding: {
                  md: 2,
                  xs: 0,
                  sm: 0,
                },
                pr: 2,
                pl: {
                  md: 0,
                  xs: 2,
                },
                height: "100%",
                mt: 2,
              }}
            >
              <Grid
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: {
                    md: 5,
                    xs: 2,
                  },
                }}
              >
                <H3
                  fontWeight={600}
                  fontSize={16}
                  sx={{
                    pt: 2,
                    ml: 2,
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  Investment Details
                </H3>
                <Grid
                  sx={{
                    display: "flex",
                    borderTop: 0.2,
                    borderBottom: 1,
                    mt: 2,
                    borderColor: "#EEEEEE",
                  }}
                >
                  <Grid
                    sx={{
                      width: "25%",
                      alignItems: "center",
                      justifyContent: "center",
                      display: "flex",
                      flexDirection: "column",
                      borderTopColor: "#bbb",
                      borderTopWidth: 0.2,
                      mb: 0.5,
                    }}
                  >
                    <H4
                      color="#E09A09"
                      sx={{
                        width: "100%",
                        textAlign: "center",
                      }}
                      fontWeight={"500"}
                    >
                      ₹{mfDetails?.invested_amount ?? "0"}
                    </H4>
                    <H4
                      sx={{
                        fontFamily: "'Poppins', sans-serif",
                        textAlign: "center",
                      }}
                      color={"#868686"}
                    >
                      Total Investment
                    </H4>
                  </Grid>
                  <Grid
                    sx={{
                      width: "25%",
                      alignItems: "center",
                      justifyContent: "center",
                      display: "flex",
                      flexDirection: "column",

                      borderLeftWidth: "1px", // set the left border width to 2 pixels
                      borderLeftStyle: "solid", // set the left border style to solid
                      borderLeftColor: "#EEEEEE", // set the left border color

                      pt: 1,
                      pb: 1,
                    }}
                  >
                    <H4
                      color="#E09A09"
                      sx={{
                        width: "100%",
                        textAlign: "center",
                      }}
                      fontWeight={"500"}
                    >
                      ₹{mfDetails?.current_value ?? "0"}
                    </H4>
                    <H4
                      sx={{
                        fontFamily: "'Poppins', sans-serif",
                        textAlign: "center",
                      }}
                      color={"#868686"}
                    >
                      Current Amount
                    </H4>
                  </Grid>
                  <Grid
                    sx={{
                      width: "25%",
                      alignItems: "center",
                      justifyContent: "center",
                      display: "flex",
                      flexDirection: "column",
                      borderColor: "#bbb",
                      borderLeft: 1,
                      borderLeftColor: "#EEEEEE",
                    }}
                  >
                    <H4
                      color={mfDetails?.profit < 0 ? "#f00" : "#518203"}
                      sx={{
                        width: "100%",
                        textAlign: "center",
                      }}
                      fontWeight={"500"}
                    >
                      ₹{mfDetails?.profit < 0 ? "-" : null}
                      {FormatCurrency(mfDetails?.profit ?? "0")}
                    </H4>
                    <H4
                      sx={{
                        fontFamily: "'Poppins', sans-serif",
                        textAlign: "center",
                      }}
                      color={"#868686"}
                    >
                      Returns
                    </H4>
                  </Grid>
                  <Grid
                    sx={{
                      width: "25%",
                      alignItems: "center",
                      justifyContent: "center",
                      display: "flex",
                      flexDirection: "column",
                      borderColor: "#bbb",
                      borderLeft: 1,
                      borderLeftColor: "#EEEEEE",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      if (allSIPMfHoldingList?.length === 0) {
                        toast.error("You don't have any active SIP");
                        return;
                      }
                      navigate("/activesip", {
                        state: {
                          data: allSIPMfHoldingList,
                        },
                      });
                    }}
                  >
                    <H4
                      color="#518203"
                      sx={{
                        width: "100%",
                        textAlign: "center",
                      }}
                      fontWeight={"500"}
                    >
                      {allSIPMfHoldingList?.length ?? 0}
                    </H4>
                    <H4
                      sx={{
                        fontFamily: "'Poppins', sans-serif",
                        textAlign: "center",
                      }}
                      color={"#868686"}
                    >
                      Active SIPs
                    </H4>
                  </Grid>
                </Grid>
                <Grid
                  sx={{
                    width: "100%",
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex",
                    flexDirection: "column",
                    p: 1,
                  }}
                >
                  <Button
                    type="submit"
                    size="medium"
                    sx={{
                      flexDirection: "row",
                      display: "flex",
                      alignItems: "center",
                      borderRadius: 2,
                      padding: 1,
                      paddingLeft: 4,
                      color: "#fff",
                      paddingRight: 4,
                      marginTop: 1.4,
                      marginBottom: 1.4,
                      background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
                      fontSize: 14,
                      fontFamily: "'Poppins', sans-serif",
                      textTransform: "none",
                    }}
                    onClick={() => {
                      navigate("/myholdings");
                    }}
                  >
                    My Holdings
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              xs={12}
              md={4}
              sx={{
                padding: {
                  md: 4,
                  xs: 1,
                },
                pl: {
                  md: 2,
                  xs: 2,
                },
                pr: {
                  md: 2,
                  xs: 0,
                },
              }}
            >
              <Box
                sx={{
                  height: "100%",
                  background:
                    "linear-gradient(150.93deg, #FFF3DB 24.82%, rgba(246, 255, 228, 0) 83.94%)",
                  borderRadius: 5,
                  flexDirection: "row",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  pl: 2,
                  pr: 2,
                  p: 1,
                }}
              >
                <Box sx={{ pl: 1 }}>
                  <H3
                    color="#012D7E"
                    fontWeight={600}
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                    }}
                  >
                    Explore All Mutual Funds
                  </H3>
                  <H4
                    color="#868686"
                    fontSize={14}
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                    }}
                  >
                    Start small, save big - make regular savings a habit.
                  </H4>
                  <IconButton
                    sx={{
                      width: 40,
                      height: 40,
                      marginTop: 2,
                      background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
                    }}
                    onClick={() => {
                      navigate("/mutualfundcollections", {
                        state: {
                          item: SIP_Data,
                          customer: customerStatus,
                        },
                      });
                    }}
                  >
                    <Box
                      component="img"
                      sx={{
                        height: {
                          xs: "60%",
                          sm: "60%",
                          md: "90%",
                        },
                        width: {
                          xs: "60%",
                          sm: "60%",
                          md: "90%",
                        },
                      }}
                      src="https://acru-asset.s3.us-east-1.amazonaws.com/assets/Arrow.svg"
                      alt="saas-dasboard-footer"
                    />
                  </IconButton>
                </Box>
                <Box
                  component="img"
                  sx={{
                    height: {
                      xs: "60%",
                      sm: "60%",
                      md: "50%",
                    },
                    width: {
                      xs: "60%",
                      sm: "60%",
                      md: "50%",
                    },
                    transform: "scaleX(-1)",
                  }}
                  src="https://acru-asset.s3.us-east-1.amazonaws.com/assets/sip.svg"
                  alt="saas-dasboard-footer"
                />
              </Box>
            </Grid>
          </Grid>
          <H3
            fontWeight={600}
            fontSize={16}
            sx={{
              pt: 2,
              pb: 1,
              fontFamily: "'Poppins', sans-serif",
            }}
          >
            Mutual Funds Collections
          </H3>
          {/* Bigger Screen */}
          <Grid
            container
            sx={{
              pb: 2,
              pt: 1,
              justifyContent: "space-between",
              alignItems: "stretch",
              display: {
                xs: "none",
                md: "flex",
              },
            }}
          >
            {MUTUAL_FUND_TYPES?.map((item: any, index) => (
              <Box sx={{ cursor: "pointer" }}>
                <Grid
                  sx={{
                    alignItems: "center",
                    justifyItems: "center",
                    display: "flex",
                    flexDirection: "column",
                  }}
                  onClick={() => {
                    if (item.title === "Save Tax") {
                      setOpenModal(true);
                      setTaxItem(item);
                    } else {
                      navigate("/mutualfundcollections", {
                        state: {
                          item: item,
                          customer: customerStatus,
                        },
                      });
                    }
                  }}
                >
                  <Box
                    sx={{
                      alignItems: "center",
                      justifyContent: "center",
                      display: "flex",
                      flexDirection: "row",
                      objectFit: "contain",
                    }}
                  >
                    <Box
                      sx={{
                        background: "#fff",
                        p: 1,
                        borderRadius: "50%",
                        height: 60,
                        width: 60,
                        alignItems: "center",
                        justifyContent: "center",
                        display: "flex",
                      }}
                    >
                      <Box
                        component="img"
                        sx={{
                          height: {
                            xs: 20,
                            sm: 20,
                            md: 35,
                          },
                          minwidth: {
                            xs: 20,
                            sm: 20,
                            md: 35,
                          },
                        }}
                        src={item.icon}
                        alt="saas-dasboard-footer"
                      />
                    </Box>
                  </Box>
                  {item.title === "Invest with ₹100" ? (
                    <H5
                      fontWeight={500}
                      color="#000"
                      sx={{
                        width: "100%",
                        textAlign: "center",
                        mt: 1.5,
                        flexDirection: "row",
                        display: "flex",
                      }}
                    >
                      <H5
                        fontWeight={400}
                        color="#000"
                        sx={{
                          mr: 0.5,
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        Invest with{" "}
                      </H5>
                      ₹
                      <H5
                        fontWeight={400}
                        color="#000"
                        sx={{
                          
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >100
                      </H5>
                    </H5>
                  ) : (
                    <H5
                      color="#000"
                      fontWeight={400}
                      sx={{
                        width: "100%",
                        textAlign: "center",
                        mt: 1.5,
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {item.title}
                    </H5>
                  )}
                </Grid>
              </Box>
            ))}
          </Grid>
          {/* Mobile Screen */}
          <Grid
            container
            sx={{
              pb: 2,
              pt: 1,
              justifyContent: "space-between",
              alignItems: "stretch",
              flexWrap: "wrap",
              display: {
                xs: "flex",
                md: "none",
              },
            }}
          >
            {MUTUAL_FUND_TYPES?.map((item: any, index) => (
              <Box
                sx={{
                  cursor: "pointer",
                  width: "33.33%", // Set the width to 33.33% to accommodate 3 items per line
                  flexBasis: "33.33%", // Set the flex basis to 33.33% to accommodate 3 items per line
                  marginBottom: "1rem", // Add some spacing between the lines
                }}
              >
                <Grid
                  sx={{
                    alignItems: "center",
                    justifyItems: "center",
                    display: "flex",
                    flexDirection: "column",
                  }}
                  onClick={() => {
                    if (item.title === "Save Tax") {
                      setOpenModal(true);
                      setTaxItem(item);
                    } else {
                      navigate("/mutualfundcollections", {
                        state: {
                          item: item,
                          customer: customerStatus,
                        },
                      });
                    }
                  }}
                >
                  <Box
                    sx={{
                      alignItems: "center",
                      justifyContent: "center",
                      display: "flex",
                      flexDirection: "row",
                      objectFit: "contain",
                    }}
                  >
                    <Box
                      sx={{
                        background: "#fff",
                        p: 1,
                        borderRadius: "50%",
                        height: 60,
                        width: 60,
                        alignItems: "center",
                        justifyContent: "center",
                        display: "flex",
                      }}
                    >
                      <Box
                        component="img"
                        sx={{
                          height: {
                            xs: 35,
                            sm: 20,
                            md: 35,
                          },
                          minwidth: {
                            xs: 35,
                            sm: 20,
                            md: 35,
                          },
                        }}
                        src={item.icon}
                        alt="saas-dasboard-footer"
                      />
                    </Box>
                  </Box>
                  {item.title === "Invest with ₹100" ? (
                    <H5
                      fontWeight={400}
                      color="#000"
                      sx={{
                        width: "100%",
                        textAlign: "center",
                        mt: 1.5,
                        flexDirection: "row",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <H5
                        fontWeight={400}
                        color="#000"
                        sx={{
                          mr: 0.5,
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        Invest with{" "}
                      </H5>
                      ₹
                      <H5
                        fontWeight={400}
                        color="#000"
                        sx={{
                          ml: 0.5,
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        100
                      </H5>
                    </H5>
                  ) : (
                    <H5
                      color="#000"
                      fontWeight={400}
                      sx={{
                        width: "100%",
                        textAlign: "center",
                        mt: 1.5,
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {item.title}
                    </H5>
                  )}
                </Grid>
              </Box>
            ))}
          </Grid>
          <H3
            fontWeight={600}
            fontSize={16}
            sx={{
              pb: 1,
              mt: 1,
              fontFamily: "'Poppins', sans-serif",
            }}
          >
            Explore
          </H3>
          <Grid
            container
            spacing={0}
            columns={16}
            sx={{
              flexGrow: 1,
              mt: 1,
              ml: 0.5,
              justifyContent: "space-between",
              alignItems: "stretch",
              cursor: "pointer",
            }}
          >
            {FUNDS_CATEGORY_TILES.map((item, index) => (
              <GradientCard
                bgColor={item.bgColor}
                image={item.icon}
                heading={item.name}
                subheading={item.subheading}
                onPress={() => {
                  navigate("/mutualfundcollections", {
                    state: {
                      item: item,
                    },
                  });
                }}
              />
            ))}
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default MFDashboard;
const buttonView = {
  flexDirection: "row",
  display: "flex",
  alignItems: "center",
  borderRadius: 2,
  padding: 1,
  paddingLeft: 2,
  width: "30%",
  textTransform: "none",
  color: "#fff",
  paddingRight: 2,
  marginTop: 0.5,
  background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
  fontSize: 14,
};
const iconButton = {
  color: "#fff",
  marginTop: 0.5,
  background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,

  width: 50,
  height: 50,
};
